import { render, staticRenderFns } from "./NoDataToView.vue?vue&type=template&id=e60ff0c4&"
import script from "./NoDataToView.vue?vue&type=script&lang=js&"
export * from "./NoDataToView.vue?vue&type=script&lang=js&"
import style0 from "./NoDataToView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports